var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMouth18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224 -440)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.583 1.38387C190.198-0.596175 185.806-0.182165 182.835 2.4639 182.655 2.6079 164.599 17.9983 98.9982 17.9983 33.4516 17.9983 15.3593 2.62591 15.3593 2.62591 12.4969-0.254166 8.0863-0.79418 4.55784 1.14987 1.04738 3.14792-0.716854 7.25202 0.273276 11.1761 0.453299 11.9681 20.868 90.0001 98.9982 90.0001 177.128 90.0001 197.543 11.9681 197.741 11.1761 198.695 7.34202 196.949 3.41792 193.583 1.38387Z",
    fill: "#664500",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 -1 226 532)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth18);
export default __webpack_public_path__ + "static/media/mouth18.a2f1c84fe2eb6dd6ada735532880bf98.svg";
export { ForwardRef as ReactComponent };